import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";
import App from "./App";
import Memorize from "./components/memorize/Memorize";
import NotFoundPage from "./components/NotFoundPage";
import Footer from "./components/Footer";
import TabularDigitToLetter from "./components/memorize/TabularDigitToLetter";
import TabularData from "./components/memorize/TabularData";

function Layout() {
  console.log(
    "%cCongratulations! 🎉 You've reached here 😁. If you're impressed by this app, imagine what I can do for your team! 😊 Hire me and let's create something amazing together. 💼",
    "font-size: 16px; font-weight: bold; color: #333; background-color: #ffc107; padding: 10px; border-radius: 5px;"
  );

  return (
    <>
      <Outlet />
      <Footer />
    </>
  );
}

const browserRouter = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { path: "", element: <App /> },
      {
        path: "memorize",
        element: <Memorize />,
      },
      { path: "digit_to_letter", element: <TabularDigitToLetter /> },
      { path: "all_data_list", element: <TabularData /> },
    ],
    errorElement: <NotFoundPage />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={browserRouter}></RouterProvider>
  </React.StrictMode>
);
